import React from 'react';

// src/components/TradingStatusIndicator.js
const TradingStatusIndicator = ({ status }) => (
  <div className={`p-3 rounded-lg ${
    status.isOpen 
      ? 'bg-green-100 text-green-800 border border-green-200'
      : 'bg-gray-100 text-gray-800 border border-gray-200'
  }`}>
    <div className="flex items-center">
      <div className={`w-3 h-3 rounded-full mr-2 ${
        status.isOpen ? 'bg-green-500 animate-pulse' : 'bg-gray-500'
      }`} />
      <span className="font-medium">
        {status.isOpen ? 'Live Market Data' : 'Cached Portfolio Data'}
      </span>
    </div>
    {!status.isOpen && status.nextOpen && (
      <p className="text-sm mt-1">Next trading session: {status.nextOpen}</p>
    )}
  </div>
);

export default TradingStatusIndicator;